import { useState } from 'react';
import WorkflowServices from '../../../../../Services/WorkflowServices';
import ImpersonatingServices from '../../../../../Services/ImpersonatingServices';

import SystemServices from '../../../../../Services/SystemServices';
import { CreateProcessRequest, ProcessWorkflowState } from '../../../../../Services/WorkflowServicesTypes';

type CrudEmerchInsightsType = {
	loadWorkflowState: (callbackSuccess: (itemProcesses: ProcessWorkflowState[]) => void,
		callbackError: (error: any) => void, signal: { aborted: any; }) => void,
	accountWorkflowRequest: (item: CreateProcessRequest[], callbackSuccess: () => void, callbackError: () => void, signal: { aborted: any; }) => void
}

export function crudEmerchInsights($http, $rootScope, $routeParams): CrudEmerchInsightsType {
	const impersonatingServices = new ImpersonatingServices($rootScope, $routeParams);
	const impersonatedAccount = impersonatingServices.getImpersonatedAccount();
	const accountId = impersonatedAccount || $rootScope.User.Account.Key;

	const [fakeGetProcessCallNumber, setFakeGetProcessCallNumber] = useState<number>(0);
	const [useFake] = useState<boolean>(false);
	const incr = () => setFakeGetProcessCallNumber(i => i + 1);
	const workflowServices = new WorkflowServices(accountId, $http, { getProcessCallNumber: fakeGetProcessCallNumber, useFake, incr });
	const systemServices = new SystemServices($rootScope);

	function loadWorkflowState(callbackSuccess: (itemProcesses: ProcessWorkflowState[]) => void, callbackError: (error: any) => void, signal: { aborted: any; }) {
		if (signal?.aborted) {
			console.warn('Request canceled');
			return;
		}
		workflowServices.getProcesses(
			(data: ProcessWorkflowState[]) => {
				if (callbackSuccess) callbackSuccess(data);
			},
			(err: any, dataError: any) => {
				console.warn('error', err);
				console.warn('=>(dataError', dataError);
				systemServices.showError();
				if (callbackError) callbackError(err);
			}
		);
	}

	function accountWorkflowRequest(item: CreateProcessRequest[], callbackSuccess: () => void, callbackError: () => void, signal: { aborted: any; }) {
		if (signal?.aborted) {
			console.warn('Request canceled');
			return;
		}
		workflowServices.accountWorkflowRequest(
			item, () => {
				callbackSuccess();
				systemServices.showSuccess('Request has been sent');
			},
			(err: any, dataError: any) => {
				console.warn('error', err);
				console.warn('=>(dataError', dataError);
				systemServices.showError();
				callbackError();
			}
		);
	}



	return {
		loadWorkflowState,
		accountWorkflowRequest
	};
}
